import Dashboard from './container'
export { Dashboard }
export default Dashboard